let audio = null; // Declare a persistent audio object
let isPlaying = false;

export const video_modal = (data) => {
    AudioPlayer(data)
    return ({ type: 'VIDEO_MODAL', data: { video_modal: data } })
};
export const audio_modal = (data) => {
    AudioPlayer(data)
    return ({ type: 'AUDIO_MODAL', data: { audio_modal: data } })
};

const handleUserGesture = () => {
    if (audio && isPlaying) {
        audio.play().catch(() => {});
    }
    document.removeEventListener("pointerdown", handleUserGesture);
    document.removeEventListener("click", handleUserGesture);
    document.removeEventListener("keydown", handleUserGesture);
};

const AudioPlayer = (data) => {
    if (!audio) {
        audio = new Audio("/assets/img/ringtone-1-275863.mp3");
        audio.loop = true; // Set the audio to loop infinitely
    }

    if (data) {
        isPlaying = true;
        audio.currentTime = 0;
        audio.play().catch((error) => {
            console.warn("Autoplay prevented by browser. Adding interaction listener:", error);
            document.addEventListener("pointerdown", handleUserGesture, { once: true });
            document.addEventListener("click", handleUserGesture, { once: true });
            document.addEventListener("keydown", handleUserGesture, { once: true });
        });
    } else {
        isPlaying = false;
        document.removeEventListener("pointerdown", handleUserGesture);
        document.removeEventListener("click", handleUserGesture);
        document.removeEventListener("keydown", handleUserGesture);
        if (audio) {
            audio.pause();
            audio.currentTime = 0;
        }
    }
};